/**
 * Is used to identify address fields within the components to set their visibilities and display errors.
 */
export enum AddressField {
  POSTAL_CODE = 'POSTAL_CODE',
  CITY = 'CITY',
  HOUSE_NUMBER = 'HOUSE_NUMBER',
  PROVINCE = 'PROVINCE',
  COUNTRY = 'COUNTRY',
  STREET = 'STREET',
  ADDRESS_LINE_1 = 'ADDRESS_LINE_1',
  ADDRESS_LINE_2 = 'ADDRESS_LINE_2',
  POST_BOX = 'POST_BOX',
}
